var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSelectedFilledCheckbox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 18C4.33333 18 2.91667 17.4167 1.75 16.25C0.583333 15.0833 0 13.6667 0 12V6C0 4.33333 0.583333 2.91667 1.75 1.75C2.91667 0.583333 4.33333 0 6 0H12C13.6667 0 15.0833 0.583333 16.25 1.75C17.4167 2.91667 18 4.33333 18 6V12C18 13.6667 17.4167 15.0833 16.25 16.25C15.0833 17.4167 13.6667 18 12 18H6ZM8 13L14 7L12.6 5.6L8 10.2L5.8 8L4.4 9.4L8 13Z",
    fill: "#007DFF"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectedFilledCheckbox);
export default __webpack_public_path__ + "static/media/selectedFilledCheckbox.7e4ab2c15878df375daaa9304a85ba54.svg";
export { ForwardRef as ReactComponent };